import React, { useState } from 'react';
import InputControls from './InputControls';
import TerminalOutput from './TerminalOutput';

const CsapCalculator = () => {
  const [clients, setClients] = useState(2);
  const [fullEngagements, setFullEngagements] = useState(true);

  const BASE_RATE = 4750;
  const FULL_RATE = 11250;
  const currentRate = fullEngagements ? FULL_RATE : BASE_RATE;
  const monthlyRevenue = clients * currentRate;
  const annualRevenue = monthlyRevenue * 12;

  return (
    <section className="w-full max-w-5xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
      <div className="mb-8 text-center md:text-left">
        <p className="text-[10px] tracking-widest uppercase text-slate-500 font-mono mb-3">
          ▸ The Business Case
        </p>
        <h2 className="text-3xl sm:text-4xl font-oswald text-white font-bold tracking-tight mb-3 uppercase leading-tight">
          Project Your{' '}
          <span className="text-[#00E5FF]" style={{ textShadow: '0 0 20px rgba(0,229,255,0.3)' }}>
            Practice Revenue
          </span>
        </h2>
        <p className="text-sm text-slate-400 max-w-xl font-inter leading-relaxed">
          Input your projected client volume to see the ROI of your{' '}
          <span className="text-slate-200 font-semibold">certification investment.</span>
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
        <InputControls
          clients={clients}
          setClients={setClients}
          fullEngagements={fullEngagements}
          setFullEngagements={setFullEngagements}
        />
        <TerminalOutput
          monthlyRevenue={monthlyRevenue}
          annualRevenue={annualRevenue}
        />
      </div>

      <div
        className="bg-[#060c1a] border border-[#1a2238] p-5 sm:p-6 rounded-lg flex flex-col md:flex-row items-center justify-between gap-4"
        style={{ boxShadow: '0 0 40px rgba(0,0,0,0.4)' }}
      >
        <div className="text-center md:text-left">
          <h3 className="text-lg sm:text-xl font-oswald text-white uppercase tracking-wide leading-snug">
            Your break-even point is literally{' '}
            <span className="text-[#00E5FF]" style={{ textShadow: '0 0 12px rgba(0,229,255,0.3)' }}>
              one meeting.
            </span>
          </h3>
          <p className="text-slate-500 mt-1 text-xs font-inter">
            Stop the fear. Start the fix. Secure your practice.
          </p>
        </div>
        <a
          href="https://theaict.com/certification"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full md:w-auto flex-shrink-0 bg-transparent border-2 border-[#00E5FF] text-[#00E5FF] font-bold uppercase tracking-widest py-3 px-7 text-xs text-center transition-all duration-200 hover:bg-[#00E5FF] hover:text-[#060c1a] font-inter whitespace-nowrap"
          style={{ boxShadow: '0 0 15px rgba(0,229,255,0.15)' }}
        >
          Unlock CSAP Access ($100 Off)
        </a>
      </div>
    </section>
  );
};

export default CsapCalculator;